import React, {useState} from 'react';
import FilterBall from "../FilterBall";
import Header from "./Header";
import Body from "./Body";
import LinkBotton from "../BottomLink";


const ResultNight = (props) => {

    const {items, indexResult, isDraw} = props;
    const [activeDigit, setActiveDigit] = useState(0);

    return (
        <React.Fragment>
            <div className="box_kqxs">
                <Header drawAt={items.drawAt}/>
                <div className="content result-night">
                    <table cellPadding="0" cellSpacing="0"
                           className="bkqmiennam bkqmienbac" width="100%">
                        <tbody>
                        <tr>
                            <td valign="top">
                                <Body isDraw={isDraw} items={items} indexResult={indexResult}/>
                                <FilterBall activeDigit={activeDigit} setActiveDigit={setActiveDigit}
                                            indexResult={indexResult}/>
                                <div id="DDM1-08-06-2021" className="boxdauduoimien"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="bottom">
                    <div className="bkl">
                        <div className="bkr">
                            <div className="bkm"/>
                        </div>
                    </div>
                </div>
            </div>
            <LinkBotton/>
        </React.Fragment>
    )

};

export default (ResultNight)
